export default __webpack_public_path__ + "static/media/icon_performance.276f900e.svg";